export default {
    data() {
        return {
            routeName: null,
            tabName: null,
            search: {},
            list: {},
            resp: null,
            paginator: {},
            order_by: {},
        }
    },
    watch: {
        '$route.query': function () {
            var vm = this;

            vm.load();
        },
    },
    created() {
        if (this.$route)
            this.order_by = this.$route.query.order_by;

        this.load();
    },
    methods: {
        async _search() {
            return {};
        },

        _getList(resp) {
            return resp.data.data;
        },

        async _delete() {
            return {};
        },

        _beforeSearch() { },

        load() {
            if (!this.$route) return;

            this.search = { ...this.$route.query };

            this.$orderBy.reset(this.search);

            this._doSearch();
        },

        sortBy(columnName) {
            this.$orderBy.setColumn(columnName);

            const query = this.$orderBy.toQuery();

            if (query) {
                this.search.order_by = query.order_by;
                this.search.sort_by = query.sort_by;
            }

            this.doSearch();
        },

        doSearch() {
            const query = this.$orderBy.toQuery();

            if (query) {
                this.search.order_by = query.order_by;
                this.search.sort_by = query.sort_by;
            } else {
                delete this.search.order_by;
                delete this.search.sort_by;
            }

            this.$router.replace({
                name: this.routeName,
                query: this.search
            });
        },

        async _doSearch() {
            var vm = this;

            const search = { ...this.search };
            this._beforeSearch(search);

            try {
                vm.$loading.on([vm.routeName, vm.tabName, 'list'].join('_'));

                var resp = await this._search(search);
                var data = null;

                data = resp.data;

                this.list = this._getList(resp);

                this.paginator = data.meta;

                vm.autoRedirect();
            } catch (error) {
                vm.$flash.error(error.response.data.message);
            }

            vm.$loading.off([vm.routeName, vm.tabName, 'list'].join('_'));
        },

        async destroy(id, is_permanent = 0) {
            var vm = this;

            vm.$alert.confirm(vm.$t('basic.alert.delete'), async function (result) {
                if (result.isConfirmed) {
                    var params = {
                        id: id,
                        is_permanent: is_permanent
                    };

                    try {
                        vm.$loading.on([vm.routeName, vm.tabName, 'delete', id].join('_'));

                        var resp = await vm._delete(params);

                        vm._doSearch();

                        vm.$flash.success(resp.data.message);
                    } catch (error) {
                        vm.$flash.error(error.response.data.message);
                    }

                    vm.$loading.off([vm.routeName, vm.tabName, 'delete', id].join('_'));
                }
            });
        },

        autoRedirect() {
            var currPage = this.paginator.current_page;
            var lastPage = this.paginator.last_page;

            if (parseInt(currPage) > parseInt(lastPage)) {
                this.search.page = lastPage;
                this.doSearch();
            }
        },

        clear() {
            const currentIsDeleted = this.search.is_deleted;

            // reset semua search
            this.search = {};

            // kembalikan is_deleted jika ada
            if (currentIsDeleted !== undefined && currentIsDeleted !== null) {
                this.search.is_deleted = currentIsDeleted;
            }

            // reset sorting
            this.$orderBy.reset(null);

            this.doSearch();
        },

        goto(page) {
            this.search.page = page;
            this.doSearch();
        },

        setTrash(deleted) {
            var vm = this;

            vm.search.deleted = deleted;
            vm.doSearch();
        },
    }
};
